import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getPopupReasonString } from "../../../../AdminApi/commFunc";
import { getEllipsis, getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import { useApi } from "../../../../hooks/useApi";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import LineBtn from "../../../Button/LineBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import PopupTemplateModal from "./PopupTemplate/PopupTemplateModal";

export interface IPopupTemplateSave {
  buttonLink: string;
  buttonName: string;
  content: string;
  id: number;
  isbutton: number;
  title: string;
  writer: string;
  type: number;
  typeString: string;
  detail: string;
  update: string;
}

interface IPopupTemplate extends IPopupTemplateSave {
  update: string;
  writerId: number;
}

export default function PopupTemplate() {
  const [page, setPage] = useState(0);
  const [templateList, setTemplateList] = useState([]);
  const [makeTemplateModal, setMakeTemplateModal] = useState(false); // 팝업 템플릿 추가
  const [viewTemplateModal, setViewTemplateModal] = useState(false); // 팝업 템플릿 조회
  const [templateData, setTemplateData] = useState<IPopupTemplateSave>({
    buttonLink: "",
    buttonName: "",
    content: "",
    id: 0,
    isbutton: 0,
    title: "",
    type: 0,
    writer: "",
    typeString: "",
    detail: "",
    update: "",
  });

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: `popup/message`,
  });

  // 팝업 사유 조회
  const {
    response: typeRes,
    error: typeError,
    loading: typeLoading,
    fetchData: typeFetchData,
  } = useApi({
    method: "get",
    url: response?.data?.length > 0 ? `popup/type` : ``,
  });

  const tableHead = [
    "No",
    "팝업 사유",
    "템플릿 타이틀",
    "템플릿 내용",
    "작성자",
    "최종 수정 일시",
    "템플릿 확인",
  ];

  useEffect(() => {
    if (error || typeError) {
      toast.error(
        typeError?.data ??
          error?.data ??
          "팝업 템플릿을 조회하는 데에 실패하였습니다."
      );
    }
  }, [error, typeError]);

  useEffect(() => {
    if (response?.status === 200) {
      setTemplateList(response?.data?.reverse());
    }
  }, [response]);

  return (
    <>
      <SpaceBetween style={{ marginBottom: 12 }}>
        <div />

        <LineBtn
          btnText="팝업 템플릿 추가"
          icon="add"
          btnHeight={38}
          btnClickEvent={() => setMakeTemplateModal(true)}
        />
      </SpaceBetween>

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {typeRes?.status === 200 &&
              templateList?.map((d: IPopupTemplate, i: number) => {
                return (
                  <TableBody key={i}>
                    <TableBodyItem>{d?.id}</TableBodyItem>
                    <TableBodyItem>
                      {getPopupReasonString(d?.type, typeRes?.data)}
                    </TableBodyItem>
                    <TableBodyItem>{d?.title}</TableBodyItem>
                    <TableBodyItem>{getEllipsis(d?.content, 20)}</TableBodyItem>
                    <TableBodyItem>{d?.writer}</TableBodyItem>
                    <TableBodyItem>{d?.update}</TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="보기"
                        btnClickEvent={() => {
                          setTemplateData({
                            buttonLink: d?.buttonLink,
                            buttonName: d?.buttonName,
                            content: d?.content,
                            id: d?.id,
                            isbutton: d?.isbutton,
                            title: d?.title,
                            type: d?.type,
                            typeString: getPopupReasonString(
                              d?.type,
                              typeRes?.data
                            ),
                            writer: d?.writer,
                            detail: d?.detail ?? "",
                            update: d?.update ?? "",
                          });

                          setViewTemplateModal(true);
                        }}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.length : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {(loading || typeLoading) && <Loader />}

      {(makeTemplateModal || viewTemplateModal) && (
        <PopupTemplateModal
          closeEvent={() => {
            if (makeTemplateModal) {
              setMakeTemplateModal(false);
            } else {
              setViewTemplateModal(false);
            }
          }}
          confirmEvent={() => {
            fetchData({
              method: "get",
              url: `popup/message`,
            });
            typeFetchData({
              method: "get",
              url: `popup/type`,
            });
          }}
          type={makeTemplateModal ? "input" : "view"}
          templateData={viewTemplateModal ? templateData : undefined}
        />
      )}
    </>
  );
}
